import React from 'react';
import ChatLinkPreviewCard from './ChatLinkPreviewCard';
import { getMessageLinkPreviews } from './linkPreviewCollection';

export default function ChatLinkPreviewList({ message, autoFollow = true }: { message: any; autoFollow?: boolean }) {
  const previews = getMessageLinkPreviews(message);
  if (previews.length === 0) return null;

  return (
    <div className="chat-link-preview-list" role="list" aria-label="メッセージ内のリンク">
      {previews.map((preview, index) => (
        <div key={`${preview?.url || 'link'}:${index}`} className="chat-link-preview-list__item" role="listitem">
          <ChatLinkPreviewCard
            preview={preview}
            autoFollow={autoFollow}
          />
        </div>
      ))}
    </div>
  );
}
